import { inject, InjectionToken } from '@angular/core';
import { CommonsTranslationService } from '@jump-tech-frontend/app-config';
import { get } from 'lodash';

export interface TranslationProvider {
  getTranslation(path: string): string;
}

export const TRANSLATIONS_PROVIDER = new InjectionToken<TranslationProvider>('TranslationsProvider', {
  providedIn: 'root',
  factory: () => {
    const translationsService = inject(CommonsTranslationService);
    translationsService.loadTranslations();
    return {
      getTranslation(path: string): string {
        return get(translationsService.i18ns, path) as string;
      }
    };
  }
});
